import React from 'react'
import { Title } from '../../assets/styles/commonStyles'
import styled from 'styled-components';
import { Carousel } from '../../components';
import { useEffect } from 'react';
import { useContext } from 'react';
import { CartContext } from '../../context/CartContext';
import { ToastContainer } from 'react-toastify';



const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2rem 0;
  @media screen and (max-width:768px){
    margin-top: 30px;
  }

  h1{
    margin-bottom:80px;
  }

  @media screen and (max-width: 768px) {
    h1{
      margin-bottom:20px !important;
    }
  }
`
const MyWork = () => {
  const {setCart} = useContext(CartContext)
  useEffect(()=>{
    // get the cart items from the localstorage
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
    // eslint-disable-next-line
  },[])
  return (
    <>
    <Section className='animated slideInDown'>
      <Title>MY WORK</Title>
      <Carousel />
    </Section>
    <ToastContainer
      position="bottom-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{textAlign:'center'}}
      />
    </>
  )
}

export default MyWork